
import Layout from '@/layout/TheLayout.vue'
import { EXTRANET_GROUPS } from './utils'

export default [
  {
    path: '/',
    name: 'Users',
    component: Layout,
    // Por permiso de Backend solo administradores pueden acceder a esta ruta
    children: [
      {
        path: '/usuarios',
        name: 'Usuarios',
        component: () => import('@/pages/Users/Listing/index.vue'),
        meta: {
          title: 'Usuarios',
          showInSidebar: true,
          icon: 'mdi-human-child',
          ifInGroup: ['Admin'],
          excludeGroup: EXTRANET_GROUPS
        }
      }
    ]
  }
]
